// extracted by mini-css-extract-plugin
export default {"charity-manage-assets-form":"styles__charity-manage-assets-form___QtwxO","readOnly":"styles__readOnly___ZKKL6"};